(function(root){'use strict';
function direction(dx,dy){return Math.abs(dx)>=44&&Math.abs(dx)>Math.abs(dy)*1.35?(dx<0?1:-1):0;}
const transitions=new WeakMap();
function transitionPlan(direction,reduced=false){if(reduced)return null;const d=direction<0?-1:1;return {outgoing:[{transform:'translateX(0%)'},{transform:'translateX('+(-d*100)+'%)'}],incoming:[{transform:'translateX('+(d*100)+'%)'},{transform:'translateX(0%)'}],options:{duration:280,easing:'cubic-bezier(.22,.65,.3,1)',fill:'both'}};}
function cancelTransition(container){transitions.get(container)?.();}
function transition({container,from,to,direction,bounds}){
 if(!container||!from||!to||from===to)return;
 cancelTransition(container);
 const plan=transitionPlan(direction,Boolean(root.matchMedia?.('(prefers-reduced-motion: reduce)').matches));if(!plan)return;
 const document=container.ownerDocument,overlay=document.createElement('div'),old=document.createElement('img'),next=document.createElement('img');
 if(typeof old.animate!=='function')return;
 overlay.className='koll-swipe-transition';overlay.setAttribute('aria-hidden','true');
 if(bounds){Object.assign(overlay.style,{inset:'auto',left:bounds.left+'px',top:bounds.top+'px',width:bounds.width+'px',height:bounds.height+'px'});}
 old.src=from;next.src=to;old.alt=next.alt='';overlay.append(old,next);container.append(overlay);
 const animations=[old.animate(plan.outgoing,plan.options),next.animate(plan.incoming,plan.options)];
 let finished=false;const cleanup=()=>{if(finished)return;finished=true;animations.forEach(a=>a.cancel());overlay.remove();if(transitions.get(container)===cleanup)transitions.delete(container);};
 transitions.set(container,cleanup);Promise.allSettled(animations.map(a=>a.finished)).then(cleanup);
}
function bind(target,options){
 if(!target||target.dataset.kollSwipeBound)return;
 target.dataset.kollSwipeBound='true';
 const pointers=new Set();let start=null,blocked=false,suppressUntil=0;
 const scale=()=>root.visualViewport?.scale||1;
 const enabled=()=>scale()<=1.02&&options.canSwipe();
 const isControl=el=>Boolean(el?.closest?.('a,input,select,textarea,button:not(.koll-gallery-slide)'));
 const finish=()=>{if(!pointers.size){start=null;blocked=false;}};
 target.addEventListener('pointerdown',event=>{
  if(event.pointerType!=='touch')return;
  pointers.add(event.pointerId);
  if(pointers.size>1||event.isPrimary===false){blocked=true;start=null;return;}
  if(!enabled()||isControl(event.target)){start=null;return;}
  start={id:event.pointerId,x:event.clientX,y:event.clientY,lock:null};blocked=false;
 },{passive:true});
 target.addEventListener('pointermove',event=>{
  if(!start||blocked||start.id!==event.pointerId)return;
  const dx=event.clientX-start.x,dy=event.clientY-start.y;
  if(!enabled()){start=null;return;}
  if(!start.lock){
   if(Math.abs(dy)>12&&Math.abs(dy)>=Math.abs(dx)){start=null;return;}
   if(Math.abs(dx)>12&&Math.abs(dx)>Math.abs(dy)*1.35){start.lock='x';try{target.setPointerCapture?.(event.pointerId);}catch{}}
  }
  if(start?.lock==='x'&&event.cancelable)event.preventDefault();
 },{passive:false});
 target.addEventListener('pointerup',event=>{
  if(event.pointerType!=='touch')return;
  pointers.delete(event.pointerId);
  if(start?.id===event.pointerId&&!blocked&&enabled()){
   const dx=event.clientX-start.x,dy=event.clientY-start.y;
   const step=direction(dx,dy);
   if(start.lock==='x'||step){suppressUntil=Date.now()+450;if(event.cancelable)event.preventDefault();}
   if(step)options.step(step);
   start=null;
  }
  finish();
 },{passive:false});
 target.addEventListener('pointercancel',event=>{pointers.delete(event.pointerId);start=null;blocked=true;finish();},{passive:true});
 target.addEventListener('click',event=>{if(Date.now()<suppressUntil){event.preventDefault();event.stopImmediatePropagation();}},true);
 target.addEventListener('dragstart',event=>event.preventDefault());
 const syncZoom=()=>{const zoomed=scale()>1.02;target.style.touchAction=zoomed?'auto':'';target.querySelectorAll?.('img').forEach(img=>{img.style.touchAction=zoomed?'auto':'';});if(zoomed)start=null;};
 root.visualViewport?.addEventListener('resize',syncZoom,{passive:true});syncZoom();
}
root.KollGalleryGestures={bind,direction,transition,transitionPlan,cancelTransition};if(typeof module!=='undefined')module.exports={bind,direction,transitionPlan};
})(typeof window!=='undefined'?window:globalThis);
